// components/TeamSection.tsx

'use client'; 

import HeaderTitle from './HeaderTitle';
import TeamMemberCard from './TeamMemberCard';
import { useMemo, useState } from 'react'; 
import { TeamData } from '@/types/team';
import TeamMemberModal from './TeamMemberModal'; // Import the new modal component

interface TeamSectionProps {
  title: string;
  members: TeamData[];
  isparent: boolean;
}

export const TeamSection: React.FC<TeamSectionProps> = ({ title, members, isparent }) => {
  // State to manage which team member is selected for the modal
  const [selectedMember, setSelectedMember] = useState<TeamData | null>(null);

  const sortedMembers = useMemo(
    () => [...members].sort((a, b) => a.serial - b.serial),
    [members]
  );

  // Function to close the modal
  const handleCloseModal = () => {
    setSelectedMember(null);
  };

  return (
    <>
      <section className="">
        <div className="max-w-7xl mx-auto px-4">
          <HeaderTitle title={title} url="" btnText="" />
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
            {sortedMembers.map((member) => (
              <TeamMemberCard
                key={member.id}
                isparent={isparent}
                imageUrl={member.media?.[0]?.url || '/placeholder.jpg'}
                name={member.name}
                role={member?.position?.name}
                onClick={() => setSelectedMember(member)} // Set the selected member on click
              />
            ))}
          </div>
        </div>
      </section>

      {/* Conditionally render the modal */}
      {selectedMember && (
        <TeamMemberModal 
          member={selectedMember} 
          onClose={handleCloseModal} 
        />
      )}
    </>
  );
};